<template>
  <mf-confirm-dialog
    v-model="value"
    :title="title"
    confirm-text="Excluir"
    cancel-text="Cancelar"
    confirm-color="vermelho-d20"
    cancel-color="cinza-d20"
    :confirm-loading="confirmButtonLoading"
    :cancel-loading="cancelButtonLoading"
    :message="message"
    :hide-action-buttons="hideActionsButtons"
    dark
    @confirm="onConfirm"
    @cancel="onCancel"
  >
    <template v-slot:additional-content>
      <div v-if="step === 1 && status === 'PROCESSING'" class="search-segments-container">
        <div class="search-segments-text">
          <div class="search-spinner"></div>
          <span class="search-text">Buscando segmentos vinculados</span>
        </div>
        <div class="search-cancel-button">
          <mf-button label="Cancelar exclusão e fechar" color="cinza-d10" outlined @click="onCancel" />
        </div>
      </div>
      <div v-else-if="step === 2 && !isEmpty" class="list-campaigns-container">
        <div class="list-omni-campaigns">
          <div v-if="omniCampaigns.length" class="campaign-type-title">
            <img :src="require('@/assets/icons/mar.ia-grey.svg')" alt="Logo da mar.ia" />
            <span class="campaign-type-text">{{ campaignsLabels.maria }}</span>
          </div>
          <div v-for="campaign in omniCampaigns" :key="campaign._id" class="campaign-item">
            <span class="campaign-title">{{ campaign.title }}</span>
          </div>
        </div>
        <div v-for="(campaigns, index) in campaigns" :key="index" class="list-campaigns">
          <div v-if="campaigns.length" class="campaign-type-title">
            <img v-if="index === 'whatsapp'" :src="require('@/assets/icons/whatsapp.svg')" alt="Logo whatsapp" />
            <mf-icon v-else color="cinza-d10" size="16" fill>{{ campaignsIcons[index] }} </mf-icon>
            <span class="campaign-type-text">{{ campaignsLabels[index] }}</span>
          </div>
          <div v-for="campaign in campaigns" :key="campaign._id" class="campaign-item">
            <span class="campaign-title">{{ campaign.title }}</span>
          </div>
        </div>

        <div class="list-raffles">
          <div v-if="raffles.length" class="campaign-type-title">
            <mf-icon color="cinza-d10" size="16" fill>{{ campaignsIcons.raffle }}</mf-icon>
            <span class="campaign-type-text">{{ campaignsLabels.raffle }}</span>
          </div>
          <div v-for="campaign in raffles" :key="campaign._id" class="campaign-item">
            <span class="campaign-title">{{ campaign.title }}</span>
          </div>
        </div>
      </div>
      <div v-else-if="isEmpty" class="campaigns-empty-state">
        <span>Nenhuma campanha encontrada.</span>
      </div>
    </template>
  </mf-confirm-dialog>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { wsClient } from '@/services/webSocket'
import { SUBSCRIPTION_DELETE_AHUB_REPORT_ANALYTICS } from '../../../graphql'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'DeleteReportDialog',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    reportId: {
      type: String,
      default: '',
    },
    reportModel: {
      type: String,
      default: '',
    },
    reportTitle: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    step: 0,
    roomId: '',
    status: '',
    loading: false,
    confirmButtonLoading: false,
    cancelButtonLoading: false,
    omniCampaigns: [],
    campaigns: {
      email: [],
      push: [],
      sms: [],
      whatsapp: [],
      chatbotPush: [],
    },
    raffles: [],
  }),
  computed: {
    ...mapGetters(['entitiesLinkedByHubConfiguration']),
    isEmpty() {
      if (this.step === 2) {
        const campaignsTotalLength = Object.values(this.campaigns).reduce((sum, arr) => typeof arr === 'object' && sum + arr?.length, 0)
        return this.raffles.length + this.omniCampaigns.length + campaignsTotalLength === 0
      } else return false
    },
    hideActionsButtons() {
      return this.step === 1
    },
    getModelLabel() {
      return this.reportModel === 'RECURRENT' ? 'análise recorrente' : 'análise isolada'
    },
    title() {
      return `Excluir ${this.getModelLabel}`
    },
    campaignsLabels() {
      return {
        sms: 'Campanha SMS',
        push: 'Campanha App',
        email: 'Campanha E-mail',
        whatsapp: 'Campanha Whatsapp',
        chatbotPush: 'Campanha Chatbot',
        maria: 'Campanha da Mar.ia',
        raffle: 'Sorteio',
      }
    },
    campaignsIcons() {
      return {
        sms: 'chat',
        push: 'mail',
        email: 'phone_iphone',
        chatbotPush: 'smart_toy',
        raffle: 'local_activity',
      }
    },
    message() {
      const stepsMessages = [
        `Tem certeza que deseja excluir a ${this.getModelLabel} <span style="color:#0063C6 ; font-weight: 700;">${this.reportTitle}</span>? Todos os segmentos vinculados a essa análise serão perdidos após essa exclusão.`,
        'Antes de excluir precisamos verificar se nenhum segmento que está atrelado a essa análise está sendo utilizado em alguma campanha. Ao excluir a análise, se existir algum segmento em campanha, ele será transformado em estático.',
      ]
      return this.step ? stepsMessages[1] : stepsMessages[0] || ''
    },
  },
  async mounted() {
    const roomId = uuidv4()
    this.roomId = roomId
    const self = this
    await wsClient.subscribe(
      {
        query: SUBSCRIPTION_DELETE_AHUB_REPORT_ANALYTICS,
        operationName: 'DeletedAHubReportAnalytics',
        variables: {
          roomId: self.roomId,
        },
      },
      {
        next({ data: { deletedAHubReportAnalytics } }) {
          if (deletedAHubReportAnalytics) {
            const { status, messageError } = deletedAHubReportAnalytics
            self.status = status
            if (status === 'FAILED') {
              console.error(messageError)
              self.$snackbar({ message: 'Erro ao deletar análise.', snackbarColor: 'error' })
              self.$emit('input', false)
            }
            if (status === 'SUCCESS') {
              self.$snackbar({ message: 'Análise deletada com sucesso.', snackbarColor: 'success' })
              self.refetchData()
              self.$emit('input', false)
            }
          }
        },
        error(error) {
          self.$snackbar({ message: 'Erro ao deletar análise.', snackbarColor: 'error' })
          console.error(error)
          self.loading = false
        },
      }
    )
  },
  methods: {
    ...mapActions(['deleteHubReportAnalytics', 'getHubAnalyticsLimits', 'getHubAnalyticsConfigurations', 'getEntitiesLinkedByHubConfiguration']),
    async refetchData() {
      try {
        await this.getHubAnalyticsLimits()
        await this.getHubAnalyticsConfigurations({ type: 'RFV' })
        await this.getHubAnalyticsConfigurations({ type: 'DRE' })
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao carregar análise.', snackbarColor: 'error' })
      }
    },
    async onConfirm() {
      if (!this.confirmButtonLoading) {
        try {
          this.confirmButtonLoading = true
          if (this.step === 2) {
            this.cancelButtonLoading = true
            const variables = {
              input: {
                reportConfigurationId: this.reportId,
                roomId: this.roomId,
              },
            }
            await this.deleteHubReportAnalytics(variables)
          } else {
            this.step = 1
            this.status = 'PROCESSING'
            const variables = {
              input: {
                configurationId: this.reportId,
              },
            }
            await this.getEntitiesLinkedByHubConfiguration(variables)
            if (this.entitiesLinkedByHubConfiguration) {
              const { campaigns, raffles, omniCampaigns } = this.entitiesLinkedByHubConfiguration
              this.omniCampaigns = omniCampaigns
              this.campaigns = campaigns
              this.raffles = raffles
              this.confirmButtonLoading = false
              Object.keys(this.campaigns).forEach((key, index) => {
                if (!this.campaigns[key].length) {
                  delete this.campaigns[key]
                }
              })
              delete this.campaigns.__typename
              this.step = 2
            }
          }
        } catch (error) {
          console.error(error)
          this.$snackbar({ message: 'Erro ao deletar análise.', snackbarColor: 'error' })
        }
      }
    },
    onCancel() {
      if (!this.cancelButtonLoading) {
        this.$emit('input', false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search-segments-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  .search-cancel-button {
    display: flex;
    justify-content: center;
  }
  .search-segments-text {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10px;
    .search-text {
      color: $marca-0-l40;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
    }
    .search-spinner {
      width: 16px;
      height: 16px;
      border: 3.5px solid transparent;
      border-top-color: $marca-0-l40;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    }
  }
}
.campaigns-empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    color: $cinza-0;
    padding: 10px 0 5px 0;
  }
}
.list-campaigns-container {
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  max-height: 250px;
  overflow-y: auto;
  gap: 24px;
  .campaign-type-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
  .list-omni-campaigns,
  .list-campaigns,
  .list-raffles {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .campaign-item {
      display: flex;
      flex-direction: column;
      gap: 2px;
      img {
        width: 16px;
        height: 16px;
      }

      .campaign-title {
        overflow: hidden;
        color: $marca-0-l40;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        font-weight: 700;
        line-height: 150%;
      }
    }
  }
}
</style>
